<template>
    <div class="row">
        <div class="col-md-12 col-sm-6 col-12">
            <div id="image">
                <a :href="image.url">
                    <img :src="image.src" :alt="image.alt" :title="image.title">
                </a>
            </div>  
        </div>
    </div>
</template>

<script>

    export default {
        name:"sidebar-image",
        props:{
            image : {
                type: Object,
                url : {
                    default : '#',
                },
            },
        },
        data(){
            return {
                
            }
        },
    }
</script>

<style scoped>
    #image{ 
        
    }
    .mid-image{
        background: black;;
        height: 90px;
        margin-bottom: 10px;
        align-items: flex-end
    }
    #image img{
        width: 100%;
    }
    #social{
        margin-top: 16px;
        background: #df9da9 ;
    }
    #social img{
        width: 100%;
    }

    @media (min-width:992px){ /* MIN WIDTH */
        #image {   
             margin-top: 20px
        }
    } 
 
    @media (max-width:768px){
         #image img{
             max-height: 270px;
         }
         
    }


    @media (max-width:576px){
         #image {   
             margin-top: 20px
         }
    }


</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/sidebar-image.vue